<template>
  <div class="qrCode">
    <div class="div_code">
      <h3>{{$formatName(name)}}</h3>
      <p style="margin-bottom: 30px;">用户号：{{code}}</p>
      <vue-qr  :text="code" :size="260"></vue-qr>
      <p class="user_code">{{address}}</p>
    </div>
  </div>
</template>

<script>
import { getUser } from "../../api";
import vueQr from 'vue-qr'
export default {
  data() {
    return {
      code: "",
      companyCode: sessionStorage.getItem("companyCode"),
      name: "",
      address: "",
    };
  },
  components: {
    vueQr
  },
  mounted() {
    this.code = this.$route.query.code;
    getUser({
      companyCode: this.companyCode,
      code: this.code,
    }).then((res) => {
      this.name = res.data.name;
      this.address = res.data.address;
    });
  },
};
</script>

<style>
.qrCode {
  min-height: 90%;
}
.qrCode .div_code {
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
  display: inline-block;
  border-radius: 5px;
  width: 90%;
  padding: 50px 0;
  background: #fff;
  text-align: center;
}
.qrCode .div_code h3 {
  white-space: nowrap;
  font-weight: 530;
  font-size: 15px;
}
.qrCode .div_code p:not(.user_code) {
  color: rgb(114, 112, 112);
  /* text-align: left; */
}
.qrCode .user_code {
  margin-top: 20px;
  color: rgb(114, 112, 112);
}
.qrCode .cell_item {
  display: flex;
  color: #c1c1c1;
  /* background: #c1c1c1; */
  justify-content: space-between;
  padding: 0 3%;
  border-bottom: 1px solid #eee8e8;
}
.qrCode .qrcode {
  /* margin-top: 50px; */
  text-align: center;
  /* position: absolute; */
  /* left: 50%; */
  /* transform: translateX(-50%); */
}
.qrCode .div_code img {
  display: inline !important;
}
</style>



// WEBPACK FOOTER //
// src/view/fzxx/qRcode.vue